import React from 'react';
import PropTypes from 'prop-types';
import {logoutStart} from '../../../../../redux/actions';
import {connect} from 'react-redux';
import {selectAuth} from '../../../../../redux/selectors';
import {ConfirmComponent} from '../../../../../components/common/ConfirmComponent';
import {LogoutOutlined} from '@ant-design/icons';
import {PRIMARY_50} from '../../../../../style/GlobalColors';

const LogoutButton = ({auth, handleLogoutStart}) => {

  return (
    <ConfirmComponent
      confirmMessage={'Do you want to logout?'}
      confirmButtonType={'link'}
      onConfirm={() => handleLogoutStart(auth)}
      confirmStyle={{
        color: PRIMARY_50,
        paddingLeft: 0,
        width: '100%',
        textAlign: 'left',
      }}
    >
      <LogoutOutlined style={{lineHeight: 'inherit'}} />
            Logout
    </ConfirmComponent>
  );
};

LogoutButton.propTypes = {
  auth: PropTypes.object.isRequired,
  handleLogoutStart: PropTypes.func.isRequired,
};

const actions = {
  handleLogoutStart: logoutStart,
};

const mapState = state => {
  const auth = selectAuth(state);
  return {auth};
};

export default connect(mapState, actions)(LogoutButton);
